import { render, staticRenderFns } from "./ZohoLeads.vue?vue&type=template&id=21f9a730"
import script from "./ZohoLeads.vue?vue&type=script&lang=js"
export * from "./ZohoLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports